import { useTranslation } from 'react-i18next'

import styles from './LimitPerSalePoint.module.scss';


type Props = {
  currency: string
  targetName: string
  value: string | null
}

export const LimitPerSalePoint = ({ currency, targetName, value }: Props) => {
  const { t } = useTranslation('cafeteria')

  return (
    <div className={styles.root}>
      {/* "Сумма лимита в «{{target}}»:" */}
      {t('settings_limit_summ_in', { target: targetName })}

      {value === null
        ? t('settings_limit_absent', 'Отсутствует')
        : <>
          {`\u00A0${value}\u00A0`}
          {/* "{{currency}}/день", */}
          {t('settings_limit_units', { currency })}
        </>}
    </div>
  )
}
